var exports = {
  "kL": "GroupInvitesBottomSheet.module__container___dDVXZ3",
  "Gv": "GroupInvitesBottomSheet.module__backButton___dDVXZ3",
  "j2": "GroupInvitesBottomSheet.module__backIcon___dDVXZ3",
  "XG": "GroupInvitesBottomSheet.module__scroller___dDVXZ3",
  "Qs": "GroupInvitesBottomSheet.module__content___dDVXZ3",
  "g4": "GroupInvitesBottomSheet.module__loadingContainer___dDVXZ3",
  "KQ": "GroupInvitesBottomSheet.module__loadingText___dDVXZ3",
  "do": "GroupInvitesBottomSheet.module__emptyContainer___dDVXZ3",
  "BI": "GroupInvitesBottomSheet.module__emptyText___dDVXZ3",
  "IH": "GroupInvitesBottomSheet.module__inviteList___dDVXZ3",
  "Lu": "GroupInvitesBottomSheet.module__inviteItem___dDVXZ3",
  "EM": "GroupInvitesBottomSheet.module__inviteDetails___dDVXZ3",
  "fn": "GroupInvitesBottomSheet.module__inviteUrl___dDVXZ3",
  "U5": "GroupInvitesBottomSheet.module__inviteInfo___dDVXZ3",
  "R5": "GroupInvitesBottomSheet.module__revokeButton___dDVXZ3",
  "kQ": "GroupInvitesBottomSheet.module__revokeIcon___dDVXZ3",
};

module.exports = exports;
